import { Pipe, Inject, PLATFORM_ID, PipeTransform } from '@angular/core';
import { DOMParser } from 'xmldom';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { DomSanitizer, SafeResourceUrl, SafeHtml , SafeUrl} from '@angular/platform-browser';
@Pipe({
  name: 'sanitizeIframe',
  pure: true
})
export class SanitizeIframe {
  private isServer:boolean;

  constructor(
    @Inject(PLATFORM_ID) private platformId: string,
    private sanitizer : DomSanitizer
  ) { 
    this.isServer = isPlatformServer(this.platformId);
  }

  transform(htmlContent: any) {
    return this.sanitizer.bypassSecurityTrustHtml( htmlContent );
  }
}

@Pipe({
  name: 'sanitize',
  pure: true
})
export class SanitizePipe {

  private isServer:boolean;
  constructor(@Inject(PLATFORM_ID) private platformId: string) { 
    this.isServer = isPlatformServer(this.platformId);
  }


  handleExternalScriptsInHtmlString(string) {
    let that = this;
    var parser = new DOMParser();
    
    var scripts = parser.parseFromString(string, 'text/html').getElementsByTagName('js');
    var results = [];

    for (var i = 0; i < scripts.length; i++) {
      var src = scripts[i].getAttribute('src');
      var id = scripts[i].getAttribute('id');
      var obj = {src:src, id:id};

      if (src.length && results.indexOf(obj) === -1) {
        results.push(obj);
        that.addScript(obj);
      }
    }

    return results;
  }

  addScript(obj) {
    if(!this.isServer)
    {
      if(obj.id && !document.getElementById(obj.id))
      {
        var script = document.createElement('script');
        script.setAttribute('src', obj.src);
        script.setAttribute('id', obj.id);
        document.body.appendChild(script);
      }
      
    }
  }


  transform(htmlContent: any) {
    //let sanitizeHtmlContent = this.domSanitizer.bypassSecurityTrustHtml(htmlContent);

    this.handleExternalScriptsInHtmlString(htmlContent);

    return htmlContent;
  }
}
@Pipe({
  name: 'safeUrl'
})
export class SafeUrlPipe implements PipeTransform {
  constructor(private domSanitizer: DomSanitizer) { }
  transform(url) {
      return this.domSanitizer.bypassSecurityTrustResourceUrl(url);
  }
}

@Pipe({
  name: 'safeHtml'
})
export class SafeHtmlPipe implements PipeTransform {
  constructor(private domSanitizer: DomSanitizer) { }
  transform(html) {
      return this.domSanitizer.bypassSecurityTrustHtml(html);
  }
}


// WEBPACK FOOTER //
// ./src/angular-shared-features/feature/shared-pipe/sanitize.pipe.ts